const Loader = ({show}) => {

    return (
        show ?
            <div className="pt-3 pb-3 text-center cssload-container">
                <div className="cssload-bell">
                    <div className="cssload-circle">
                        <div className="cssload-inner"></div>
                    </div>
                    <div className="cssload-circle">
                        <div className="cssload-inner"></div>
                    </div>
                    <div className="cssload-circle">
                        <div className="cssload-inner"></div>
                    </div>
                    <div className="cssload-circle">
                        <div className="cssload-inner"></div>
                    </div>
                    <div className="cssload-circle">
                        <div className="cssload-inner"></div>
                    </div>
                </div>
            </div>
            : <></>
    )
}

export default Loader;